
import React, { useEffect, useState } from 'react'
import { NavBar } from 'components/NavBar/NavBar'
import { TextDisplayCard } from 'components/TextDisplayCard/TextDisplayCard'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import {
    Flex,
    Button,
    Separator,
    H2,
    PageWrapper,
    H1WithBack,
    ItemsGrid,
} from 'styling/GlobalStyles'
import { clearWorkerComponent, getSingleWorkerComponent } from 'features/workerComponents/workerComponentsSlice'
import { workerComponentTypes } from './workerComponentsData'
import { OtherText } from 'styling/Typography'
import { FieldsModal, fieldTypes, IFieldsModal } from 'components/Modal/FieldsModal'

export const SingleWorkerComponent = () => {
    const [modal, setModal] = useState(false)
    const dispatch = useDispatch<AppDispatch>()
    const { singleWorkerComponent, noSubfields } = useSelector((store: RootState) => store.workerComponents)
    const { id } = useParams()

    useEffect(() => {
        dispatch(getSingleWorkerComponent(Number(id)))

        return () => {
            dispatch(clearWorkerComponent())
        }
    }, [])

    const convertDataForModal = (): IFieldsModal => {
        return {
            id: Number(id),
            name: singleWorkerComponent?.name,
            type: fieldTypes.find(t => t.value == singleWorkerComponent.dataType),
            dropDownItems: singleWorkerComponent.dropDownItems?.map(i => ({ id: Number(i.id), name: i.name, type: fieldTypes.find(t => t.value == i.dataType) })),
            unit: singleWorkerComponent?.unit ? { value: singleWorkerComponent?.unit?.id, label: singleWorkerComponent?.unit.name } : null,
            workerComponentType: workerComponentTypes.find(w => w.value == singleWorkerComponent?.componentType)
        }
    }

    const dataTypes = ['Text', 'Number', 'DropDown']

    return (
        <>
            <NavBar />

            <PageWrapper>
                <Flex between>
                    <H1WithBack title={singleWorkerComponent?.name} arrow />
                    <Button orange onClick={() => setModal(true)}>
                        Edit Component
                    </Button>
                </Flex>
                <Separator />
                <H2 mb='1'>Field</H2>
                <Flex gap='1rem' center>
                    <TextDisplayCard width='15rem' title={singleWorkerComponent?.name} labelText='Field name' />
                    {singleWorkerComponent?.unit?.name && (
                        <TextDisplayCard title={singleWorkerComponent?.unit?.name} labelText='Field unit' />
                    )}
                    <TextDisplayCard title={dataTypes[singleWorkerComponent?.dataType - 1]} labelText='Data type' />
                    <TextDisplayCard title={workerComponentTypes?.find(t => t.value == singleWorkerComponent?.componentType)?.label} labelText='Data type' />
                </Flex>
                <Flex gap='1rem' m='2rem 0' column>
                    <H2>Subfields</H2>
                    {!noSubfields ? (
                        singleWorkerComponent?.dropDownItems?.map((item) => {
                            return (
                                <ItemsGrid columns={2} gap='1rem' key={item.id} width='60%'>
                                    <TextDisplayCard labelText='Data type' title={dataTypes[item.dataType - 1]} />
                                    <TextDisplayCard labelText='Value' title={item.name} />
                                </ItemsGrid>
                            )
                        })
                    ) : (
                        <OtherText>No Subfields</OtherText>
                    )}
                </Flex>
            </PageWrapper>
            {modal &&
                <FieldsModal closeModal={() => setModal(false)} value={convertDataForModal()} workerComponents />
            }
        </>
    )
}
